import { useMemo, useState } from "react";

import type { RecognitionUser } from "@/api/profiles";

import { buildPreviewFillParams } from "@/api/dragon-tiles/previewUserContext";
import { useParentDragonTileId } from "@/hooks/useParentDragonTileId";

export function useTextPreviewProfile(
  siteId: string,
  innerTileId: string | undefined,
) {
  const [selectedProfile, setSelectedProfile] =
    useState<RecognitionUser | null>(null);
  const dragonTileId = useParentDragonTileId(siteId, innerTileId);

  const previewFillParams = useMemo(() => {
    const inner = (innerTileId ?? "").trim();
    const dragon = (dragonTileId ?? "").trim();
    if (!inner || !dragon) return undefined;
    return buildPreviewFillParams(selectedProfile, {
      dragonTileId: dragon,
      innerTileId: inner,
    });
  }, [dragonTileId, innerTileId, selectedProfile]);

  return { selectedProfile, setSelectedProfile, previewFillParams };
}
